import { AvailabilitySlot, DayOfWeek, PlannedRoute } from "@/types/collections"

/**
 * The slots a day is meant to collect and nothing is planned for.
 *
 * Shared by the panel and the badge on the button that opens it, so the two numbers cannot
 * disagree. Misscheduled stops are not counted: a stop at the wrong time is already on a route,
 * and lumping it in with the sites nobody is collecting from turns the badge into a number that
 * means nothing in particular.
 *
 * Pass every route the date runs, not the ones a search happens to be showing. A slot is
 * unscheduled because nothing collects it that day.
 */
export function selectUnscheduledSlots(
  slots: AvailabilitySlot[],
  routes: PlannedRoute[],
  day: DayOfWeek,
): AvailabilitySlot[] {
  const scheduled = new Set<string>()
  for (const route of routes) {
    for (const stop of route.stops) {
      if (stop.locationId) scheduled.add(stop.locationId)
    }
  }

  return slots.filter(
    (slot) =>
      slot.is_active &&
      Boolean(slot.days?.includes(day)) &&
      !scheduled.has(slot.location_id),
  )
}
